import { useEffect, useState } from 'react';
import CategoryTable from '../componets/Category/CategoryTable';
import Header from '../componets/Layout/Header';
import Sidebar from '../componets/Layout/Sidebar';
import Pagination from '../componets/Pagination';
import { getCategory } from '../controller';
import { requestHandler } from '../helper';



function Category() {
  const [categoryData, setCategoryData] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const [status, setStatus] = useState("");

  const [activeTab, setActiveTab] = useState('Category');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };


  const getCategoryData = async () => {
    await requestHandler(
      async () => await getCategory(page, perPage, status, searchQuery),
      null,
      (res) => {
        const { category, perPage, page, paginationValue } = res.data;
        setCategoryData(category);
        setPerPage(perPage);
        setPage(page);
        setPaginationValue(paginationValue);
      },
      () => { }
    );
  };



  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getCategoryData();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, page, status]); // 

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1); // Reset to the first page when search changes
  };

  const handleStatusChange = (newValue) => {
    setStatus(newValue);
    setPage(1);
  }

  return (
    <>
      <div className='layouy-main'>
        <div className='sidebar-hide-show'>
          <Sidebar />
        </div>
        <div className='w-100'>
          <Header />

          <div className="tebs-title">
            <p className={activeTab === 'Category' ? 'active' : ''} onClick={() => handleTabClick('Category')}>Category</p>
          </div>
          <section>
            <div className="card main-card">
              <div className="card-body px-0 pt-0">
                <div className="table-main">
                  <div className="card">
                    <div className="card-body">
                      <div className='tables-container'>
                        <div className={activeTab === 'Category' ? 'Category' : 'hidden'}>
                          <CategoryTable categoryData={categoryData} searchQuery={searchQuery} handleSearchChange={handleSearchChange} onStatusChange={handleStatusChange} perPage={perPage} page={page} getCategoryData={getCategoryData} status={status} />
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className='d-flex justify-content-center mt-4'>
                    {paginationValue > 1 && (
                      <Pagination
                        currentPage={page}
                        totalPages={paginationValue}
                        onPageChange={(newPage) => {
                          setPage(newPage);
                        }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default Category